export default __webpack_public_path__ + "static/media/desert.cda9403373ff680f963fd396e6dca1e7.svg";